module.exports = __webpack_public_path__ + "static/media/checkoutBag.ab3ef52a.png";